import { IonSpinner } from "@ionic/react";
import styled, { css } from "styled-components";

export interface StyledButtonProps {
	children?: React.ReactNode;
	onClick?: () => void;
	disabled?: boolean;
	loading?: boolean;
	isPrimary?: boolean;
}

export const StyledButton = styled.button<any>`
	height: 40px;
	padding: 0 1rem;
	width: max-content;
	background: #f4c60a;
	color: #000;
	border-radius: 4px;
	font-weight: 600;
	font-size: 18px;
	display: flex;
	justify-content: center;
	align-items: center;
	text-transform: uppercase;

	${(props) =>
		!props.isPrimary &&
		css`
			background: transparent;
			color: #f4c60a;
			border: 1px solid #f4c60a;
		`}

	${(props) =>
		props.isDisabled &&
		css`
			pointer-events: none;
			&:before {
				content: "";
				display: block;
				position: absolute;
				top: 0;
				left: 0;
				width: 100%;
				height: 100%;
				background-color: rgba(0, 0, 0, 0.5); 
			}
		`}
`;

const Button = ({ children, onClick, disabled, loading, isPrimary }: StyledButtonProps) => {
	const isDisabled = loading || disabled;
	return (
		<StyledButton disabled={isDisabled} onClick={onClick} isPrimary={isPrimary}>
			{loading ? <IonSpinner color={"#000"} name="dots" /> : children}
		</StyledButton>
	);
};

export default Button;
